import React from 'react'
import { Linking, Platform } from 'react-native'
import { FontAwesome5 as Icon } from '@expo/vector-icons'
import { RedesSociaisModel } from '@/domain/models'
import { useMediaQueries, useTheme } from '@/presentation/hooks'
import { IconButton, HStack, phoneModalNumberState, phoneModalState } from '@/presentation/components'
import { useSetRecoilState } from 'recoil'

type SocialMidiasProps = {
  socialMidias: RedesSociaisModel
  color?: string
  size?: number
}

export const SocialMidias: React.FC<SocialMidiasProps> = ({ socialMidias, color, size }) => {
  const { isMobile } = useMediaQueries()
  const theme = useTheme()
  const setModalOpen = useSetRecoilState(phoneModalState)
  const setModalNumber = useSetRecoilState(phoneModalNumberState)

  const handleOpenModal = (): void => {
    setModalOpen(true)
  }

  const countPhones = (): number => {
    const phoneValue = socialMidias.phone
    if (!phoneValue) return 0

    const phones = phoneValue.split('\n').filter(p => p.trim().length > 0)
    return phones.length
  }

  const callNumber = (phone: string): void => {
    setModalNumber(phone)

    if (isMobile && countPhones() === 1) {
      let phoneNumber = phone.trim().replace(/\s/g, '')

      if (!['android', 'web'].includes(Platform.OS)) {
        phoneNumber = `telprompt:${phoneNumber}`
      } else {
        phoneNumber = `tel:${phoneNumber}`
      }

      Linking.canOpenURL(phoneNumber)
        .then(async (supported: boolean) => {
          if (!supported) {
            console.error('não suportado')
          } else {
            return await Linking.openURL(phoneNumber)
          }
        })
        .catch(console.log)
    } else {
      handleOpenModal()
    }
  }

  const handleClick = (key: keyof RedesSociaisModel): void => {
    if (key === 'phone') {
      callNumber(socialMidias[key])
      return
    }

    if (key === 'whatsapp') {
      const cleanWhatsapp = socialMidias[key].replace(/\D/g, '')

      const appUrl = `whatsapp://send?phone=55${cleanWhatsapp}`
      const webUrl = `https://wa.me/55${cleanWhatsapp}`

      if (Platform.OS === 'web') {
        window.open(webUrl, '_blank')
        return
      }

      Linking.openURL(appUrl).catch(() => {
        Linking.openURL(webUrl)
      })

      return
    }

    Linking.openURL(socialMidias[key]).catch(() => {});
  }

  return (
    <HStack spacing={8} items='center' justify='center' wrap>
      {Object.keys(socialMidias).map((props: keyof RedesSociaisModel) => (
        (!!socialMidias[props] && props !== 'codUnidade') &&
        (<IconButton
          key={`${socialMidias[props].toString().replaceAll(' ', '')}-icon-button`}
          color={color ?? theme.colors.error}
          icon={<Icon key={`${socialMidias[props].toString().replaceAll(' ', '')}-icon`} color={color ?? theme.colors.white} size={size ?? 24} name={props}/>}
          onPress={() => handleClick(props)}
        />)
      ))}
    </HStack>
  )
}